/* eslint-disable import/prefer-default-export */
import {
  COLLECTION_TYPE_LOCAL_CLIPS,
  setLocalChannelCookies,
  setOutOfMarketLocalCookies,
} from 'helpers/ContentHelper';
import {
  callSegmentPlayerEvent,
  SegmentPlayerStates,
  SegmentVideoEvents,
} from '@foxcorp/delta-web-analytics';
import { getActivePlayer, getPlayerState } from 'helpers/PlayerHelper';
import { isTabletBreakpoint, isMobileBreakpoint } from 'helpers/BreakpointHelper';
import { SEARCH_TILE, LIVE_TILE } from '../index';

export const titleProcessor = ({
  breakpoint,
  isDisabled,
  isRedirect,
  isSeriesDetailAvailable,
  isUpcoming,
  target,
  title,
  titleLines,
  type,
}) => {
  let titleInfo = {
    isDisabled,
    isRedirect,
    isSeriesDetailAvailable,
    isUpcoming,
    target,
    title,
    titleLines,
  };

  switch (type) {
    case SEARCH_TILE:
      break;
    case LIVE_TILE:
      titleInfo = {
        ...titleInfo,
        breakpoint,
      };
      break;
    default:
  }
  return titleInfo;
};

const defaultPlayButtonClick = props => {
  const { segmentPlaylistButtonAction } = props;
  segmentPlaylistButtonAction();
  const currentPlayerState = getPlayerState(getActivePlayer());
  if (currentPlayerState === 'PLAYING' || currentPlayerState === 'AD') {
    callSegmentPlayerEvent({
      eventName: SegmentVideoEvents.videoPlaybackInterrupted,
      props: {
        method: 'browser action',
        video_player_state: SegmentPlayerStates.PAUSE,
      },
    });
  }
};

const playButtonClickLive = props => {
  const { collectionType, contentId, headline, isUserOutOfMarket, playerScreenUrl } = props;
  const isCollectionTypeLocalClip = collectionType === COLLECTION_TYPE_LOCAL_CLIPS;

  if (isUserOutOfMarket) {
    setOutOfMarketLocalCookies(props?.originalItem);
  }

  if (isCollectionTypeLocalClip) {
    setLocalChannelCookies({ headline, playerScreenUrl, videoId: contentId });
  }
};

export const playButtonClickProcessor = ({ type, props }) => {
  let result = () => {};
  switch (type) {
    case LIVE_TILE:
      result = () => {
        playButtonClickLive(props);
        defaultPlayButtonClick(props);
      };
      break;
    default:
      result = () => defaultPlayButtonClick(props);
      break;
  }
  return result;
};

export const isMobileDevice = breakpoint =>
  isMobileBreakpoint(breakpoint) || isTabletBreakpoint(breakpoint);
